import { AnalyticsUserEvent } from '@fruitful/types';
import React, { useCallback } from 'react';
import { BodyMediumRegular, YStack } from 'smoothie';

import { track } from '../../../logger/Logger';
import { CHAT_USER_BUBBLE } from './ChatLayout';

interface ChatSuggestionPillProps {
    text: string;
    onPress: () => void;
}

export const ChatSuggestionPill = ({
    text,
    onPress,
}: ChatSuggestionPillProps) => {
    const handlePress = useCallback(() => {
        onPress();
        track(AnalyticsUserEvent.AI_CHAT_SUGGESTED_RESPONSE_SELECTED, {
            text,
        });
    }, [onPress, text]);

    return (
        <YStack
            onPress={handlePress}
            pressStyle={{ opacity: 0.8, scale: 0.98 }}
            backgroundColor={CHAT_USER_BUBBLE.backgroundColor}
            borderRadius={CHAT_USER_BUBBLE.borderRadius}
            paddingHorizontal={CHAT_USER_BUBBLE.paddingHorizontal}
            paddingVertical={CHAT_USER_BUBBLE.paddingVertical}
            justifyContent="center"
            alignItems="center"
            flexShrink={0}
            cursor="pointer"
        >
            <BodyMediumRegular color="$black">{text}</BodyMediumRegular>
        </YStack>
    );
};
